module.exports = __webpack_public_path__ + "img/keep-punch.d393e810.png";